export const newsItems = [
  {
    id: 1,
    slug: "facility-security-permission-2024",
    date: "2024年3月",
    isoDate: "2024-03-15",
    title: "第一号警備（施設警備）を大阪府公安委員会より取得",
    excerpt:
      "株式会社GRANSTARKは、2024年3月に大阪府公安委員会より第一号警備の認定を受けました。これにより施設警備業務を開始いたします。",
    content:
      "株式会社GRANSTARKは、2024年3月に大阪府公安委員会より第一号警備（施設警備）の認定を受けました。\n\n第一号警備とは、建物・施設などの出入り管理や巡回警備、駐車場管理などを行う警備業務です。商業施設、オフィスビル、マンション、工場など、さまざまな施設の安全を守る業務となります。\n\nこの認定により、GRANSTARKはこれまでの交通誘導・高速道路警備・イベント警備に加え、施設警備という新たな分野でもお客様の安全を守ることができるようになりました。\n\n代表取締役の三田は「地域の安全を守るため、より多くの現場で警備業務を展開できることを大変嬉しく思います。引き続き、スタッフ一人ひとりのスキルアップに注力し、お客様に信頼される警備サービスを提供してまいります」とコメントしています。\n\nGRANSTARKでは、施設警備スタッフも随時募集中です。未経験者歓迎、丁寧な研修制度で安心して働けます。",
    category: "お知らせ",
    imageUrl:
      "/images/kv-main.jpg",
  },
  {
    id: 2,
    slug: "traffic-security-permission-2023",
    date: "2023年3月",
    isoDate: "2023-03-20",
    title: "第二号警備（交通警備・雑踏警備）を大阪府公安委員会より取得",
    excerpt:
      "2023年3月、株式会社GRANSTARKは大阪府公安委員会より第二号警備の認定を受け、交通誘導・イベント警備などの業務を開始いたしました。",
    content:
      "2023年3月、株式会社GRANSTARKは大阪府公安委員会より第二号警備（交通警備・雑踏警備）の認定を受けました。\n\n第二号警備には、交通誘導警備と雑踏警備（イベント警備）が含まれます。交通誘導警備では、工事現場やイベント会場周辺の交通整理、歩行者の誘導などを行います。雑踏警備では、コンサート・お祭り・スポーツイベントなど、多数の人が集まる場所での安全確保と秩序維持を行います。\n\nこの認定取得により、GRANSTARKは大阪府内のさまざまなイベントや工事現場で警備業務を展開できるようになりました。\n\n第二号警備スタッフは日給11,000円〜20,000円で、日払い・週払いにも対応しています。未経験者・シニアの方も大歓迎です。",
    category: "お知らせ",
    imageUrl:
      "/images/kv-main.jpg",
  },
  {
    id: 3,
    slug: "company-established-2019",
    date: "2019年4月",
    isoDate: "2019-04-01",
    title: "株式会社GRANSTARK 設立",
    excerpt:
      "代表取締役三田により、大阪市浪速区にて株式会社GRANSTARKを設立。地域密着型の警備会社として事業を開始しました。",
    content:
      "2019年4月、代表取締役の三田晃士により、大阪市浪速区難波中に株式会社GRANSTARK（グランシュターク）が設立されました。\n\n会社名の「GRANSTARK」には、グラン（壮大な）とシュターク（強固な）という意味が込められており、大阪の街を壮大かつ強固に守るという想いが表現されています。\n\n設立当初から「人を大切にする」ことを理念に掲げ、スタッフの働きやすさと成長を第一に考えた運営を行ってきました。この考え方が、現在の低離職率と高い現場定着率につながっています。\n\n創業以来、GRANSTARKは大阪府を中心に警備業務を展開し、地域の安全に貢献してまいりました。2019年の設立から着実に事業を拡大し、2023年には第二号警備、2024年には第一号警備の認定を取得するなど、事業領域を広げてきました。",
    category: "お知らせ",
    imageUrl:
      "/images/kv-main.jpg",
  },
];
